export default __webpack_public_path__ + "static/media/vayuda_turquoise_sliver.fddee89a.png";